import type { MainNavRenderLink } from './types'

/** The fallback when an app passes no `renderLink`: a plain anchor. */
export const defaultRenderLink: MainNavRenderLink = ({ href, className, onClick, children }) => (
  <a href={href} className={className} onClick={onClick}>
    {children}
  </a>
)
